/**
 * Animates the open/close of the collapsible block's native <details>.
 *
 * <details> snaps open with no transition, so we take over the toggle: reveal the
 * panel, measure it, and animate its height (and a soft fade) with the Web Animations
 * API. The plus/minus bars animate on their own in CSS. Without JS the <details> still
 * works, just without the slide; with reduced motion we leave the native toggle alone.
 *
 * One delegated listener for the whole page, guarded so multiple block copies (each of
 * which prints this <script>) don't stack listeners and cancel each other out.
 */
(() => {
  if (window.__jofenCollapsible) return;
  window.__jofenCollapsible = true;

  const DURATION = 300;
  const prefersReduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.collapsible__header');
    if (!summary) return;

    const details = summary.closest('.collapsible');
    const panel = details?.querySelector('[data-collapsible-panel]');
    if (!details || !panel || prefersReduced()) return; // fall back to native toggle

    event.preventDefault();
    if (details.dataset.animating) return;
    details.dataset.animating = '1';

    const settle = () => {
      panel.style.height = '';
      delete details.dataset.animating;
    };

    if (details.open) {
      const from = panel.scrollHeight;
      const anim = panel.animate(
        [{ height: `${from}px`, opacity: 1 }, { height: '0px', opacity: 0 }],
        { duration: DURATION, easing: 'ease' }
      );
      anim.onfinish = () => {
        details.open = false;
        settle();
      };
    } else {
      details.open = true;
      const to = panel.scrollHeight;
      const anim = panel.animate(
        [{ height: '0px', opacity: 0 }, { height: `${to}px`, opacity: 1 }],
        { duration: DURATION, easing: 'ease' }
      );
      anim.onfinish = settle;
    }
  });
})();
